module.exports = __webpack_public_path__ + "static/media/miota.dedad000.svg";